<template>
  <main class="hero" :style="{ background: getElementBackground }">
    <div class="hero__inner-container">
      <section class="hero__content">
        <Logo />

        <h1 class="hero__title" v-html="title"></h1>

        <Accent v-if="showAccent" class="accent-svg"/>

        <p class="hero__description" v-html="description"></p>

        <p v-if="disclaimer" class="hero__disclaimer" v-html="disclaimer"></p>

      </section>

      <section class="hero__menu">
        <ButtonMenu
          :button-list="buttonMenuList"
          :bg-color="buttonMenuBgColor"
          @action="heroMenuButton($event)"
        />

        <IconButton
          v-for="(item, index) in iconButtonList"
          :key="index"
          :label="item.label"
          :icon="item.icon"
          :disabled="item.disabled"
          @action="handleAction(item)"
        />

        <span class="hero__last-update">
          Last update: <span class="hero__date">{{ lastUpdate }}</span>
        </span>
      </section>
    </div>
  </main>
</template>

<script>
// Vuex
import { mapActions } from 'vuex';

export default {
  name: 'Hero',

  components: {
    IconButton: () => import('./IconButton.vue'),
    ButtonMenu: () => import('./ButtonMenu.vue'),
    Logo: () => import('./Logo.vue'),
    Accent: () => import('@/assets/svgs/landing-accent.svg')
  },

  props: {
    bgColor: {
      type: String,
      default: 'rgb(136, 2, 2)',
    },
    bgImage: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Title',
    },
    description: {
      type: String,
      default: 'Description',
    },
    disclaimer: {
      type: String,
      required: false,
      default: ''
    },
    buttonMenuList: {
      type: Object,
      default: () => ({}),
    },
    buttonMenuBgColor: {
      type: String,
      default: 'lightblue',
    },
    iconButtonList: {
      type: Array,
      default: () => [],
    },
    lastUpdate: {
      type: String,
      default: 'last update',
    },
    showAccent: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    getElementBackground() {
      let bg;
      if (this.bgImage) {
        bg = `${this.bgColor} url(${require('@/assets/imgs/' + this.bgImage)})`;
      } else {
        bg = `${this.bgColor}`;
      }
      return bg;
    },
  },

  methods: {
    ...mapActions(['getCurrentModal']),
    goTutorial() {
      console.log('hello');
    },
    heroMenuButton(event) {
      this.$emit('emit-route', event)
    },
    setModal(modal){
      this.getCurrentModal(modal)
    },
    openDownload(resource) {
      window.open(resource, 'blank');
    },
    handleAction(item) {
      if (item.download) {
        this.openDownload(item.download);
      } else {
        this.setModal(item.label)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hero {
  @include flexbox(flex-start, flex-start);
  padding: rem(85) rem(100) rem(40) rem(100);
  border-radius: 0 0 rem(60) 0;
  height: 95vh;
  background-size: cover !important;
  background-position: right !important;
  background-repeat: no-repeat !important;

  @include iPadProStyles {
    padding: rem(85) rem(120) rem(40) rem(120);
  }

  &__title {
    color: $white;
    font-size: rem(60);
    line-height: 0.95;
    margin: rem(60) 0 rem(20);
    font-weight: $font-medium;
  }

  &__description {
    color: $white;
    font-size: rem(22);
    line-height: 1.5;
    font-weight: $font-light;
  }

  &__disclaimer {
    color: $white;
    font-weight: $font-light;
  }

  &__content {
    flex: 1;

    .accent-svg {
      fill: white;
      margin-bottom: rem(30);
    }
  }

  &__menu {
    margin-top: rem(100);
    margin-left: 10%;

    .button-menu {
      margin-bottom: rem(30);
    }

    .icon-button {
      margin-left: rem(35);

      &:not(:last-of-type) {
        margin-bottom: rem(15);
      }
    }
  }

  &__last-update,
  &__date {
    color: $white;
    font-size: rem(10);
  }

  &__last-update {
    display: block;
    font-weight: $font-medium;
    margin-left: rem(35);
    margin-top: rem(25);
  }

  &__date {
    font-weight: $font-light;
  }

  &__inner-container {
    display: flex;
    flex: 1;

    @include iPadProStyles {
      zoom: 1.3;
    }
  }
}
</style>
